<template>
  <DefaultLayout>
    <div>
      <img v-lazy="getPhoto" class="img-fluid" />
      <div class="text-center">
        <br />
        <h2>{{ getScenario.completion_title }}</h2>
      </div>
      <span v-html="getScenario.completion_description" />
      <br />
      <div class="text-center">
        <div v-if="!disableReportingButton">
          <base-button
            type="primary"
            style="margin: 2px"
            v-on:click="openReporting()"
            >{{ $t("openreporting") }}</base-button
          >
          <br />
          <br />
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { updateGameLastPageShown, sendComment } from "@/services/APIService";
import { convertPhotoToAmazonURL } from "@/services/utils";

export default {
  components: { DefaultLayout, },
  watch: {
    getGameReportingOpen: {
      handler(newData, oldData) {
        this.openReporting();
      },
    },    
  },  
  data: function () {
    return {};
  },
  async created() {
    if (this.$store.getters.getIsFacilitator) {
      updateGameLastPageShown(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        true
      );
    }

    this.$store.dispatch("connectNotification");

    this.$store.dispatch("updateGame");

    this.$store.commit({
      type: "setCurrentCaseNumber",
      currentCaseNumber: this.$store.getters.getNumberOfCases + 1,
    });
  },
  async mounted() {
    if (this.$store.getters.getUnfinishedComment) {
      const aCase = this.$store.getters.getCaseByCaseNumber(
        this.$store.getters.getCasesInCurrentLocale.length
      );

      Swal.fire({
        text: this.$t("simulation-ended-save-or-discard-comment-1") + " " + this.$store.getters.getUnfinishedComment + " " + this.$t("simulation-ended-save-or-discard-comment-2"),
        showDenyButton: true,
        confirmButtonText: this.$t('send'),
        denyButtonText: this.$t('discard'),
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          sendComment(
            this.$store.state.main.game.id,
            this.$store.state.main.thisPlayerId,
            this.$store.getters.getUnfinishedComment,
            aCase.case,
            this.$store.state.main.game.gameCode
          ).then((resp) => {});
          
          this.$store.commit({
            type: "setUnfinishedComment",
            unfinishedComment: null,
          });
         }
      })
    }    
  },
  computed: {
    ...mapGetters([
      "getGameReportingOpen",
    ]),
    getPhoto() {
      if (this.getScenario.completion_photo) {
        return convertPhotoToAmazonURL(this.getScenario.completion_photo);
      } else {
        return "/placeholder.png";
      }
    },
    getScenario() {
      return this.$store.getters.getScenarioInCurrentLocale;
    },
    disableReportingButton() {
      return !this.$store.state.main.game.reportingOpen;
    },
  },
  methods: {
    async openReporting() {
      await this.$router.push("/reporting");
    },
  },
};
</script>

<i18n>
{
  "en": {
    "openreporting": "Open reports",
    "simulation-ended-save-or-discard-comment-1": "Simulation has ended. You have an unfinished comment that has not been submitted:",
    "simulation-ended-save-or-discard-comment-2": "Do you wish to send or discard the comment?",
    "send": "Send",
    "discard": "Discard"
  },
  "fi": {
    "openreporting": "Avaa raportit",
    "simulation-ended-save-or-discard-comment-1": "Simulaatio on päättynyt. Olet kirjoittanut kommentin, jota ei ole lähetetty:",
    "simulation-ended-save-or-discard-comment-2": "Haluatko että kommentti lähetetään vai hylätään?",
    "send": "Lähetä",
    "discard": "Hylkää"
  },
  "sv": {
    "openreporting": "Öppna rapporterna",
    "simulation-ended-save-or-discard-comment-1": "Simuleringen är slut. Du har en påbörjad kommentar som inte har skickats:",
    "simulation-ended-save-or-discard-comment-2": "Vill du sända eller slänga kommentaren?",
    "send": "Sänd",
    "discard": "Släng"
  },
  "de": {
    "openreporting": "Berichte öffnen",
    "simulation-ended-save-or-discard-comment-1": "Simulation ist beendet. Sie haben einen unvollendeten Kommentar, der noch nicht gesendet wurde:",
    "simulation-ended-save-or-discard-comment-2": "Möchten Sie den Kommentar senden oder verwerfen?",
    "send": "Senden",
    "discard": "Verwerfen"
  },
 "ko": {
    "openreporting": "결과보고서 보기",
    "simulation-ended-save-or-discard-comment-1": "시뮬레이션이 종료되었습니다. 제출되지 않은 미완성 댓글이 있습니다:",
    "simulation-ended-save-or-discard-comment-2": "댓글을 보내시겠습니까 아니면 삭제하시겠습니까?",
    "send": "보내다",
    "discard": "버리다"
  }
}
</i18n>
